import { observable, action } from 'mobx';
import gql from 'graphql-tag';

const FloorMutation = gql`
    mutation FloorMutation(
        $URLID: String!
        $RoomNum: Int!
        $RoomSection: String!
        $RoomData: String!
    ) {
        toolSubmissionMutation(
            URLID: $URLID
            RoomNum: $RoomNum
            RoomSection: $RoomSection
            RoomData: $RoomData
        ) {
            URLID
            Error
        }
    }
`;

export class FloorStore {
    appStore;

    currentRoomNum;

    @observable goNext = false;

    @action reset() {
        this.goNext = false;
    }

    constructor(opts) {
        this.appStore = opts.appStore;
        this.currentRoomNum = opts.currentRoomNum;
    }

    getMutation(values) {
        return {
            mutation: FloorMutation,
            variables: {
                URLID: this.appStore.submissionID,
                RoomNum: this.currentRoomNum,
                RoomSection: 'floor',
                RoomData: JSON.stringify(values.floor)
            },
            fetchPolicy: 'no-cache',
            context: {
                headers: {
                    'X-CSRF-TOKEN': this.appStore.sectoken
                }
            }
        };
    }

    async save(values, form, goNext) {
        this.loading = true;
        this.appStore.updateUserData(values.floor, 'floor', this.currentRoomNum);
        this.appStore.save(this.getMutation(values), this, form, goNext);
    }
}
